/**
 * CopyClipboard
 * ======================================
 * - copy text from href attribute
 */

const WIDGET = '.js-CopyClipboard'

class CopyClipboard {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET)

    this.elements.forEach((el) => {
      el.addEventListener('click', this.clickHandler, false)
    })
  }

  clickHandler = (e) => {
    const el = e.currentTarget;
    const copy = el.getAttribute('href')

    navigator.clipboard.writeText(copy).then(() => {
      console.log('Content copied to clipboard');

      el.classList.add('copied')

      setTimeout(() => {
        el.classList.remove('copied')
      }, 700);

    },() => {
      alert('Failed to copy');
    });

    e.preventDefault()
  }

}

new CopyClipboard()
